import { ReactElement, useCallback } from 'react'
import PlanElementDrawer from '@editor/components/PlanElementDrawer'
import { useSelectionStore } from '@editorStores'
import type { PlanElementType } from '@editorStores'

interface Props {
  planElementType: PlanElementType | null
}

/**
 * The selected table / comment / image card's form, which takes over the plan view's detail
 * column. Its header's close button deselects the element and brings the plan view back.
 */
const PlanViewPlanElementDrawer = ({ planElementType }: Props): ReactElement => {
  const selectPlanElement = useSelectionStore(state => state.selectPlanElement)
  const onClose = useCallback(() => selectPlanElement(null), [selectPlanElement])

  return <PlanElementDrawer planElementType={planElementType} onClose={onClose} />
}

export default PlanViewPlanElementDrawer
